import { render, staticRenderFns } from "./ProjectLinkDelete.vue?vue&type=template&id=195ed060&scoped=true"
import script from "./ProjectLinkDelete.vue?vue&type=script&lang=js"
export * from "./ProjectLinkDelete.vue?vue&type=script&lang=js"
import style0 from "./ProjectLinkDelete.vue?vue&type=style&index=0&id=195ed060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ed060",
  null
  
)

export default component.exports